import React, { InputHTMLAttributes, ReactNode } from 'react'
import { InputCopy } from 'src/editor/shared/ui-lib/input/components/input-copy'
import { twMerge } from 'tailwind-merge'

export type InputProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'onChange' | 'value' | 'onBlur'
> & {
  startElement?: ReactNode
  endElement?: ReactNode
  className?: string
  value: string
  appendix?: ReactNode
  onChange: (value: string) => void
  onCopy?: () => void
  onBlur?: (value: string) => void
}

export const Input = ({
  type = 'text',
  onChange,
  onBlur,
  value,
  startElement,
  endElement,
  className,
  appendix,
  onCopy,
  ...props
}: InputProps) => {
  return (
    <label
      htmlFor={props.id}
      className={twMerge(
        'flex h-10 w-full items-center overflow-hidden rounded-md border border-border200 px-3 py-2.5',
        className,
      )}
    >
      {appendix && (
        <div className="-ml-3 mr-2 flex rounded-l-md bg-bgSecondary px-2 py-2.5 text-M text-textSecondary">
          {appendix}
        </div>
      )}
      {startElement && (
        <div className="mr-2 [&>svg]:h-5 [&>svg]:w-5">{startElement}</div>
      )}
      <input
        className={twMerge(
          'h-auto w-full appearance-none border-none p-0 [-moz-appearance:textfield] focus:border-none focus:outline-none',
          '[&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none',
        )}
        onChange={e => {
          onChange(e.target.value)
        }}
        onBlur={e => {
          onBlur?.(e.target.value)
        }}
        value={value}
        type={type}
        {...props}
      />
      {endElement && (
        <div className="ml-2 [&>svg]:h-5 [&>svg]:w-5">{endElement}</div>
      )}
      {onCopy && <InputCopy onCopy={onCopy} />}
    </label>
  )
}
